import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { Row } from '@simplywallst/ui-core';

export const JourneyContainer = styled.div`
  position: relative;
`;

export const JourneyContainerRow = styled(Row)`
  position: static;
  background-color: #001d38;
  ${media.mdUp`
    position: absolute;
    width: 100%;
    background-color: rgba(0, 29, 56, 0.8);
    bottom: 0;
    justify-content: center;
  `};
`;

export const JourneyContentRow = styled(Row)`
  padding: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    padding: 0 ${({ theme }) => theme.x2spacePx}px;
  `}
`;

export const StyledReactMarkdown = styled('div')`
  padding: ${({ theme }) => theme.x2spacePx}px 0;
  ${media.lgUp`
    padding: ${({ theme }) => theme.x1spacePx}px 0;
  `}
  color: #fff;
  h3 {
    font-size: 43px;
    color: #fff;
    letter-spacing: -0.02em;
    margin: 0;
  }
  p {
    font-size: 16px;
    padding-right: ${({ theme }) => theme.x3spacePx}px;
    margin-bottom: 0;
    ${media.lgUp`
      ${({ theme }) => theme.typography.base};
      padding-right: ${({ theme }) => theme.x16spacePx}px;
    `}
    ${media.lgOnly`
      padding-right: ${({ theme }) => theme.x8spacePx}px;
  `}
  }
`;
